/**
 * Turn a URL pathname into a `path_taxonomy` string suitable for the
 * Faro page meta attribute bucket (flat string-only).
 *
 * The format keeps the same separator the URL already uses (`/`), trimmed
 * of leading/trailing slashes:
 *
 *   '/categoria/bolsas/femininas'  →  'categoria/bolsas/femininas'
 *   '/'                            →  ''
 *   ''                             →  ''
 *
 * Consumers (mapping JSON, downstream destinations) split on `/` if they
 * need an array. Keeping the string form means the Faro meta type
 * (`Record<string, string>`) is respected without JSON-stringify dance.
 */
export function derivePathTaxonomy(pathname: string): string {
  if (typeof pathname !== 'string') return ''
  return pathname.replace(/^\/+/, '').replace(/\/+$/, '')
}
